import { createReducer, on } from '@ngrx/store';
import { ValuesetItem } from 'src/app/shared/api/types/GraphQL';
import * as CustomLanguagesActions from './custom-languages.actions';

export interface CustomLanguageState {
  valuesetId: number;
  customLanguage: ValuesetItem[];
  error: Error;
}

export const initialState: CustomLanguageState = {
  valuesetId: undefined,
  customLanguage: [],
  error: undefined
};

export const customLanguageReducer = createReducer(
  initialState,
  on(CustomLanguagesActions.loadCustomLanguages, (state) => ({
    ...state
  })),
  on(CustomLanguagesActions.setCustomLanguagesValuesetId, (state, { valuesetId }) => ({
    ...state,
    valuesetId
  })),
  on(CustomLanguagesActions.customLanguagesSuccess, (state, { items }) => ({
    ...state,
    customLanguage: [...items]
  })),
  on(CustomLanguagesActions.customLanguagesFailure, (state, { error }) => ({
    ...state,
    error
  }))
);
